import { createFileRoute } from "@tanstack/react-router";
import CreateListingAIReview from "@/pages/dashboard/CreateListingAIReview";
import PrivateAiPlanGuard from "@/components/private/PrivateAiPlanGuard";

export const Route = createFileRoute("/vinde-masina/ai/review/$draftId/")({
  head: () => ({
    meta: [
      { title: "Verifică anunțul generat cu AI | RO Auto Market" },
      {
        name: "description",
        content: "Confirmă datele detectate din videoclip înainte de publicarea anunțului.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Verifică anunțul generat cu AI" },
      {
        property: "og:description",
        content: "Confirmă datele detectate din videoclip înainte de publicare.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <PrivateAiPlanGuard>
      <CreateListingAIReview sellerType="private" />
    </PrivateAiPlanGuard>
  ),
});
